import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-hot-toast";
import { endpoints } from "../../services/operations/api";
import "./UpdateEvent.css";

const UpdateEvent = () => {
  const { eventId } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    eventName: "",
    description: "",
    date: "",
    location: "",
    maxAttendees: "",
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchEventDetails = async () => {
      try {
        const response = await axios.get(endpoints.GET_EVENT_BY_ID_API(eventId));
        if (response.data.success) {
          const { name, description, date, location, maxAttendees } = response.data.event;
          setFormData({
            eventName: name,
            description,
            date,
            location,
            maxAttendees,
          });
        } else {
          toast.error(response.data.message || "Failed to fetch event details.");
        }
      } catch (error) {
        toast.error(error.response?.data?.message || "Error fetching event details.");
      }
    };
    fetchEventDetails();
  }, [eventId]);

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleUpdateEvent = async (e) => {
    e.preventDefault();
    setLoading(true);

    const updatedEventData = {
      name: formData.eventName,
      description: formData.description,
      date: formData.date,
      location: formData.location,
      maxAttendees: formData.maxAttendees,
    };

    try {
      const token = JSON.parse(localStorage.getItem("token"));
      if (!token) {
        toast.error("Unauthorized: No token found");
        return;
      }

      const response = await axios.put(endpoints.UPDATE_EVENT_API(eventId), updatedEventData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.data.success) {
        toast.success("Event updated successfully!");
        navigate(`/event/${eventId}`);
      } else {
        toast.error(response.data.message || "Failed to update event.");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Error updating event.");
    } finally {
      setLoading(false);
    }
  };

  const { eventName, description, date, location, maxAttendees } = formData;

  return (
    <div className="event-details">
  <div className="event-card">
    <h1 className="event-title">Edit Event</h1>
    <form onSubmit={handleUpdateEvent} className="edit-event-form">
      <div className="form-group">
        <label htmlFor="eventName">Event Name</label>
        <input
          type="text"
          id="eventName"
          name="eventName"
          placeholder="Enter event name"
          value={eventName}
          onChange={handleInputChange}
          required
        />
      </div>
      <div className="form-group">
        <label htmlFor="description">Description</label>
        <textarea
          id="description"
          name="description"
          placeholder="Enter event description"
          value={description}
          onChange={handleInputChange}
          required
        ></textarea>
      </div>
      <div className="form-group">
        <label htmlFor="date">Date</label>
        <input
          type="date"
          id="date"
          name="date"
          value={date.split("T")[0]}
          onChange={handleInputChange}
          required
        />
      </div>
      <div className="form-group">
        <label htmlFor="location">Location</label>
        <input
          type="text"
          id="location"
          name="location"
          placeholder="Enter event location"
          value={location}
          onChange={handleInputChange}
          required
        />
      </div>
      <div className="form-group">
        <label htmlFor="maxAttendees">Max Attendees</label>
        <input
          type="number"
          id="maxAttendees"
          name="maxAttendees"
          placeholder="Enter max attendees"
          value={maxAttendees}
          onChange={handleInputChange}
          required
        />
      </div>
      <div className="event-actions">
        <button type="submit" className="edit-button" disabled={loading}>
          {loading ? "Updating..." : "Update Event"}
        </button>
        <button
          type="button"
          className="delete-button"
          onClick={() => navigate("/dashboard")}
        >
          Cancel
        </button>
      </div>
    </form>
  </div>
</div>

  );
};

export default UpdateEvent;
